import { FeaturesByCategoryType } from "commonModule/services/common"

export const getAllAmenities = (arr: FeaturesByCategoryType[]) => {
  const keys: FeaturesByCategoryType["keywords"] = []
  if (arr) {
    arr.map(
      (a) =>
        a.keywords &&
        a.keywords.map((e) => {
          if (e) {
            keys.push(e)
          }
        }),
    )
  }
  return keys
}
